// Internal
import { PostAsync } from "src/common/httpRequests";
import { BUSINESS_ANALYTICS_SERVICE_URL } from "src/constants/api";
import { API_GATEWAY } from "src/constants/settings";
import { handleResponse } from "src/helpers/helpers";

const BASE_PATH = `${API_GATEWAY}${BUSINESS_ANALYTICS_SERVICE_URL}`;

// error   - something failed (4xx/5xx, caught exception, screen couldn't render)
// warning - unexpected but the user could continue (retry, fallback, deprecated path)
// info    - notable event worth tracing (e.g. user completed a key step)
export type TLogType = "error" | "warning" | "info";

export interface ILogPayload {
  logType: TLogType;
  parameters: Record<string, string>;
}

const sendLog = async (payload: ILogPayload, shouldUseToken = true) => {
  // isPreventLogout: a rejected log call must never sign the user out.
  const response = await PostAsync(
    `${BASE_PATH}/log`,
    payload,
    shouldUseToken,
    undefined,
    true,
  );
  return handleResponse<unknown>(response);
};

export { sendLog };
